import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-about',
  templateUrl: './help.about.tpl.html',
  styleUrls: ['./help.about.tpl.scss']
})
export class MobiusAbout implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

@Component({
  selector: 'app-help-fundamentals',
  templateUrl: './help.fundamentals.tpl.html',
  styleUrls: ['./help.fundamentals.tpl.scss']
})
export class HelpFundamentals implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

@Component({
  selector: 'app-help-model',
  templateUrl: './help.model.tpl.html',
  styleUrls: ['./help.model.tpl.scss']
})
export class HelpModel implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/help/info-viewer/help.template.ts